<template>
  <div class="IncrementalData-fieldWrap">
    <div
      class="IncrementalData-field"
      data-rmpdev-field-selector="userLocation"
    >
      <p class="IncrementalData-supportingText">
        Almost there! Add your location and you’ll only get jobs relevant to you.
      </p>
      <div
        class="IncrementalData-question"
      >
        <label
          class="IncrementalData-questionText"
        >
          Are you based in the UK? *
        </label>
        <div class="IncrementalData-questionField">
          <form-radio
            v-model="fields.uk_based"
            :value="1"
            label="Yes"
            name="uk_based"
            class-name="u-colCenter"
          />
          <form-radio
            v-model="fields.uk_based"
            :value="0"
            label="No"
            name="uk_based"
            class-name="u-colCenter "
          />
          <error-messages
            :manual-validate="validateAll"
            :errors="validateStatus({ field: v$.fields.uk_based, serverKey: 'uk_based', label: 'Location' }).errors"
          />
        </div>
      </div>
      <div
        v-if="fields.uk_based === 1"
        class="IncrementalData-question"
      >
        <div class="IncrementalData-questionField">
          <form-input
            v-model="fields.postcode"
            :error="validateStatus({ field: v$.fields.postcode, serverKey: 'postcode', label: 'Postcode' })"
            :manual-validate="validateAll"
            required
            label="Postcode"
            input-type="text"
            @change="validateBlur({ field: v$.fields.postcode, serverKey: 'postcode' })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import FormInput from '@/components/form/input';
import ErrorMessages from '@/components/form/partials/error-message';
import FormRadio from '@/components/form/radio-button';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    FormRadio,
    FormInput,
    ErrorMessages,
  },
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        uk_based: null,
        postcode: null,
      },
      fieldName: 'uk_based_and_postcode',
    };
  },

  computed: {
    updatePayload() {
      return {
        uk_based: this.fields.uk_based,
        postcode: this.fields.postcode,
      };
    },
  },

  mounted() {
    this.fields.uk_based = this.user.uk_based;
    this.fields.postcode = this.user.postcode;
  },

  validations() {
    const rules = {
      fields: {
        uk_based: {
          required,
        },
      },
    };

    if (this.fields.uk_based === 1) {
      rules.fields.postcode = { required };
    }

    return rules;
  },
};
</script>
